import { colors } from '../../../shared/colors'

export const QuestionNumber = ({number}: any): JSX.Element => {
    return (
        <div className='flex flex-row justify-center items-center h-8 w-8 p-3 text-white font-semibold' style={{backgroundColor: colors.primary}}>{number}</div>
    );
};
